import { aggregate } from "./../sync/_private/aggregate.js";
import { all } from "./../sync/_private/all.js";
import { allAsync } from "./../sync/_private/allAsync.js";
import { any } from "./../sync/_private/any.js";
import { anyAsync } from "./../sync/_private/anyAsync.js";
import { append } from "../sync/_private/append.js";
import { asAsync } from "./../sync/_private/asAsync.js";
import { asParallel } from "./../sync/_private/asParallel.js";
import { average } from "./../sync/_private/average.js";
import { averageAsync } from "./../sync/_private/averageAsync.js";
import { chunk } from "./../sync/_private/chunk.js";
import { concatenate } from "../sync/_private/concatenate.js";
import { contains } from "./../sync/_private/contains.js";
import { containsAsync } from "./../sync/_private/containsAsync.js";
import { count } from "./../sync/_private/count.js";
import { countAsync } from "./../sync/_private/countAsync.js";
import { defaultIfEmpty } from "../sync/_private/defaultIfEmpty.js";
import { distinct } from "./../sync/_private/distinct.js";
import { distinctAsync } from "./../sync/_private/distinctAsync.js";
import { each } from "./../sync/_private/each.js";
import { eachAsync } from "./../sync/_private/eachAsync.js";
import { elementAt } from "./../sync/_private/elementAt.js";
import { elementAtOrDefault } from "./../sync/_private/elementAtOrDefault.js";
import { except } from "./../sync/_private/except.js";
import { exceptAsync } from "./../sync/_private/exceptAsync.js";
import { first } from "./../sync/_private/first.js";
import { firstAsync } from "./../sync/_private/firstAsync.js";
import { firstOrDefault } from "./../sync/_private/firstOrDefault.js";
import { firstOrDefaultAsync } from "./../sync/_private/firstOrDefaultAsync.js";
import { groupBy } from "./../sync/_private/groupBy.js";
import { groupByAsync } from "./../sync/_private/groupByAsync.js";
import { groupByWithSel } from "./../sync/_private/groupByWithSel.js";
import { groupJoin } from "../sync/_private/groupJoin.js";
import { groupJoinAsync } from "../sync/_private/groupJoinAsync.js";
import { intersect } from "./../sync/_private/intersect.js";
import { intersectAsync } from "./../sync/_private/intersectAsync.js";
import { join } from "./../sync/_private/join.js";
import { last } from "./../sync/_private/last.js";
import { lastAsync } from "./../sync/_private/lastAsync.js";
import { lastOrDefault } from "./../sync/_private/lastOrDefault.js";
import { lastOrDefaultAsync } from "./../sync/_private/lastOrDefaultAsync.js";
import { max } from "./../sync/_private/max.js";
import { maxAsync } from "./../sync/_private/maxAsync.js";
import { min } from "./../sync/_private/min.js";
import { minAsync } from "./../sync/_private/minAsync.js";
import { ofType } from "./../sync/_private/ofType.js";
import { order } from "./../sync/_private/order.js";
import { orderBy } from "./../sync/_private/orderBy.js";
import { orderByAsync } from "./../sync/_private/orderByAsync.js";
import { orderByDescending } from "./../sync/_private/orderByDescending.js";
import { orderByDescendingAsync } from "./../sync/_private/orderByDescendingAsync.js";
import { orderDescending } from "./../sync/_private/orderDescending.js";
import { partition } from "./../sync/_private/partition.js";
import { partitionAsync } from "./../sync/_private/partitionAsync.js";
import { prepend } from "../sync/_private/prepend.js";
import { reverse } from "./../sync/_private/reverse.js";
import { select } from "./../sync/_private/select.js";
import { selectAsync } from "./../sync/_private/selectAsync.js";
import { selectMany } from "./../sync/_private/selectMany.js";
import { selectManyAsync } from "./../sync/_private/selectManyAsync.js";
import { sequenceEquals } from "./../sync/_private/sequenceEquals.js";
import { sequenceEqualsAsync } from "./../sync/_private/sequenceEqualsAsync.js";
import { single } from "./../sync/_private/single.js";
import { singleAsync } from "./../sync/_private/singleAsync.js";
import { singleOrDefault } from "./../sync/_private/singleOrDefault.js";
import { singleOrDefaultAsync } from "./../sync/_private/singleOrDefaultAsync.js";
import { skip } from "./../sync/_private/skip.js";
import { skipWhile } from "./../sync/_private/skipWhile.js";
import { skipWhileAsync } from "./../sync/_private/skipWhileAsync.js";
import { sum } from "./../sync/_private/sum.js";
import { sumAsync } from "./../sync/_private/sumAsync.js";
import { take } from "./../sync/_private/take.js";
import { takeWhile } from "./../sync/_private/takeWhile.js";
import { takeWhileAsync } from "./../sync/_private/takeWhileAsync.js";
import { toArray } from "./../sync/_private/toArray.js";
import { toMap } from "./../sync/_private/toMap.js";
import { toMapAsync } from "./../sync/_private/toMapAsync.js";
import { toObject } from "./../sync/_private/toObject.js";
import { toObjectAsync } from "./../sync/_private/toObjectAsync.js";
import { toSet } from "./../sync/_private/toSet.js";
import { union } from "./../sync/_private/union.js";
import { unionAsync } from "./../sync/_private/unionAsync.js";
import { where } from "./../sync/_private/where.js";
import { whereAsync } from "./../sync/_private/whereAsync.js";
import { zip } from "./../sync/_private/zip.js";
import { zipAsync } from "./../sync/_private/zipAsync.js";
export const bindLinq = (object) => {
    const prototype = object.prototype;
    const bind = (func, key) => {
        const wrapped = function (...params) {
            return func(this, ...params);
        };
        Object.defineProperty(wrapped, "length", { value: func.length - 1 });
        prototype[key] = wrapped;
    };
    bind(aggregate, "aggregate");
    bind(all, "all");
    bind(allAsync, "allAsync");
    bind(any, "any");
    bind(anyAsync, "anyAsync");
    bind(append, "append");
    bind(asAsync, "asAsync");
    bind(asParallel, "asParallel");
    bind(average, "average");
    bind(averageAsync, "averageAsync");
    bind(chunk, "chunk");
    bind(concatenate, "concatenate");
    bind(contains, "contains");
    bind(containsAsync, "containsAsync");
    bind(count, "count");
    bind(countAsync, "countAsync");
    bind(defaultIfEmpty, "defaultIfEmpty");
    bind(distinct, "distinct");
    bind(distinctAsync, "distinctAsync");
    bind(each, "each");
    bind(eachAsync, "eachAsync");
    bind(elementAt, "elementAt");
    bind(elementAtOrDefault, "elementAtOrDefault");
    bind(except, "except");
    bind(exceptAsync, "exceptAsync");
    bind(first, "first");
    bind(firstAsync, "firstAsync");
    bind(firstOrDefault, "firstOrDefault");
    bind(firstOrDefaultAsync, "firstOrDefaultAsync");
    bind(groupBy, "groupBy");
    bind(groupByAsync, "groupByAsync");
    bind(groupByWithSel, "groupByWithSel");
    bind(groupJoin, "groupJoin");
    bind(groupJoinAsync, "groupJoinAsync");
    bind(intersect, "intersect");
    bind(intersectAsync, "intersectAsync");
    bind(join, "joinByKey");
    bind(last, "last");
    bind(lastAsync, "lastAsync");
    bind(lastOrDefault, "lastOrDefault");
    bind(lastOrDefaultAsync, "lastOrDefaultAsync");
    bind(max, "max");
    bind(maxAsync, "maxAsync");
    bind(min, "min");
    bind(minAsync, "minAsync");
    bind(ofType, "ofType");
    bind(order, "order");
    bind(orderBy, "orderBy");
    bind(orderByAsync, "orderByAsync");
    bind(orderByDescending, "orderByDescending");
    bind(orderByDescendingAsync, "orderByDescendingAsync");
    bind(orderDescending, "orderDescending");
    bind(prepend, "prepend");
    bind(reverse, "reverse");
    bind(select, "select");
    bind(selectAsync, "selectAsync");
    bind(selectMany, "selectMany");
    bind(selectManyAsync, "selectManyAsync");
    bind(sequenceEquals, "sequenceEquals");
    bind(sequenceEqualsAsync, "sequenceEqualsAsync");
    bind(single, "single");
    bind(singleAsync, "singleAsync");
    bind(singleOrDefault, "singleOrDefault");
    bind(singleOrDefaultAsync, "singleOrDefaultAsync");
    bind(skip, "skip");
    bind(skipWhile, "skipWhile");
    bind(skipWhileAsync, "skipWhileAsync");
    bind(sum, "sum");
    bind(sumAsync, "sumAsync");
    bind(take, "take");
    bind(takeWhile, "takeWhile");
    bind(takeWhileAsync, "takeWhileAsync");
    bind(toArray, "toArray");
    bind(toMap, "toMap");
    bind(toMapAsync, "toMapAsync");
    bind(toObject, "toObject");
    bind(toObjectAsync, "toObjectAsync");
    bind(partition, "partition");
    bind(partitionAsync, "partitionAsync");
    bind(toSet, "toSet");
    bind(union, "union");
    bind(unionAsync, "unionAsync");
    bind(where, "where");
    bind(whereAsync, "whereAsync");
    bind(zip, "zip");
    bind(zipAsync, "zipAsync");
};
